export enum ERROR_TYPES {
  NO_MONEY = 'NO_MONEY',
  NO_PENDING_REQUEST = 'NO_PENDING_REQUEST',
}
